import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import SplitText from 'gsap/SplitText'
import CustomEase from 'gsap/CustomEase'
import { smoother } from './smooth-scroll.js'
import { desktop, mobile } from './check-res.js'

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin, CustomEase)

const preloader = document.querySelector('.preloader')
const preloaderBox = document.querySelector('.preloader__box')
const preloaderHole = document.querySelector('.preloader__box-hole')

const preloaderBtnsContainer = document.querySelector('.preloader__btns')
const preloaderBtns = document.querySelectorAll('.preloader__btn')

const preloaderTl = gsap.timeline({
	paused: true,
	defaults: {
		duration: 1,
		ease: 'power4.out',
	},
})

new SplitText('.preloader__title-over, .preloader__title-main, .hero__title', {
	type: 'words, chars',
	charsClass: 'char',
})

preloaderTl
	.to(
		window,
		{
			duration: 0,
			scrollTo: {
				y: 0,
				ease: 'none',
			},
		},
		0
	)
	.to(
		'.preloader__title-over, .preloader__title-main, .preloader__bg, .preloader__box-hole',
		{
			opacity: 1,
			duration: 0,
		},
		'<'
	)
	.to(
		preloaderBox,
		{
			duration: 2,
			translateY: 0,
			ease: 'power4.out',
			onComplete: () => {
				document.querySelector('.preloader').classList.add('active')
			},
		},
		'<'
	)
	.to(
		'.preloader__title-over .char, .preloader__title-main .char',
		{
			translateY: 0,
			stagger: 0.1,
		},
		'>-=0.5'
	)
	.to(
		'.preloader__title-over, .preloader__title-main',
		{
			duration: 2,
			translateX: 0,
			ease: CustomEase.create('custom', 'M0,0 C0.796,0 0.215,1 1,1 '),
		},
		'<-=0.5'
	)
	.to(
		preloaderBtnsContainer,
		{
			translateY: 0,
		},
		'>-=0.5'
	)

window.addEventListener('load', () => {
	smoother.paused(true)
	preloaderTl.play()
})

preloaderBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		if (btn.dataset.age === 'true') {
			preloaderTl
				.to(
					'.preloader__title-over .char, .preloader__title-main .char',
					{
						translateY: '105%',
						ease: 'power4.in',
						stagger: 0.03,
					},
					'>'
				)
				.to(
					preloaderBtnsContainer,
					{
						translateY: '200rem',
						ease: 'power4.in',
					},
					'<'
				)

			if (desktop) {
				preloaderTl
					.to(
						preloaderHole,
						{
							duration: 2,
							opacity: 0,
						},
						'>+=1'
					)
					.to(
						preloaderBox,
						{
							duration: 1.5,
							ease: 'power4.inOut',
							transform: 'translate(-50%, -260rem)',
						},
						'<'
					)
					.to(
						preloader,
						{
							duration: 2,
							ease: 'power4.inOut',
							scale: 8,
							onComplete: () => {
								preloader.remove()
							},
						},
						'<'
					)
			}

			if (mobile) {
				preloaderTl
					.to(
						preloaderBox,
						{
							duration: 1.5,
							ease: 'power4.inOut',
							transform: 'translate(-50%, 0)',
						},
						'<'
					)
					.to(
						preloader,
						{
							duration: 2,
							ease: 'power4.inOut',
							scale: 6,
							opacity: 0,
							onComplete: () => {
								preloader.remove()
							},
						},
						'>'
					)
			}

			preloaderTl
				.to(
					'.hero__inner',
					{
						translateY: 0,
						ease: 'power4.out',
						duration: 2,
					},
					'<'
				)
				.to(
					'.hero__title-wrap .char',
					{
						translateY: 0,
						stagger: 0.05,
					},
					'>-=0.5'
				)
				.to(
					'.hero__title-main .char',
					{
						translateY: 0,
						stagger: 0.1,
					},
					'<'
				)
				.to(
					'.hero__title-wrap, .hero__title-main',
					{
						duration: 2,
						translateX: 0,
						ease: CustomEase.create('custom', 'M0,0 C0.796,0 0.215,1 1,1 '),
						onComplete: () => {
							smoother.paused(false)
						},
					},
					'<-=0.5'
				)
		}

		if (btn.dataset.age === 'false') {
			console.log("👀 Think you're a hacker? Don’t forget to show your passport.")

			preloaderTl
				.to(
					'.preloader__title-over .char, .preloader__title-main .char',
					{
						translateY: '105%',
						ease: 'power4.in',
						stagger: 0.03,
					},
					'>'
				)
				.to(
					preloaderBtnsContainer,
					{
						translateY: '200rem',
						ease: 'power4.in',
					},
					'<'
				)
		}
	})
})
